export const news = {
  newsFeedCreateInputPlaceholder: 'Створити допис...',
  newsFeedSearchInputPlaceholder: 'Пошук',
  newsFeedPostOwnerCurtainEditTitle: 'Редагувати допис',
  newsFeedPostOwnerCurtainDeleteTitle: 'Видалити допис',
  newsFeedEditedPostSavedAlertText: 'Допис збережено!',
  newsFeedEditedPostDeletedAlertText: 'Допис видалено!',
  newsFeedShareCurtainOptionTitle: 'Скопіювати посилання',
  newsFeedPostLinkCopiedAlertText: 'Посилання скопійовано!',
  newsFeedOthersPostCurtainOptionCopyTitle: 'Скопіювати посилання',
  newsFeedOthersPosLinkCopiedAlertText: 'Посилання скопійовано!',
  newsFeedOthersPostCurtainOptionFlagTitle: 'Поскаржитись',
  newsFeedOtherPostOwnersCurtainDeleteTitle: 'Видалити допис',
  newsFeedPostDeletePopupTitle: 'Видалити',
  newsFeedPostDeletePopupText: 'Видалити цей допис?',
  newsFeedPostDeletePopupCancelButtonTitle: 'Скасувати',
  newsFeedPostDeletePopupConfirmButtonTitle: 'Підтвердити',
  newsFeedPostDeeletedAlertText: 'Допис видалено!',
  newsPostDetailsHeaderTitle: 'Допис',
  postFeedPostLikesText: 'Вподобання',
  postFeedPostCommentsText: 'Коментарі',
  postFeedPostNoLikesText: 'Поки що жодного вподобання.',
  postFeedPostLeaveFirstLikeText: 'Залиш перше вподобання',
  newsFeedPostDetailsNoCommentsText: 'Поки що жодних коментарів',
  newsFeedPostDetailsFirstCommentText: 'Залиш перший коментар',
  newsFeedPostDetailsShareOptionTitle: 'Скопіювати посилання',
  newsFeedPostDetailsSharePostCopiedAlertText: 'Посилання скопійовано!',
  newsFeedPostDetailsUsersCurtainCopyOptionTitle: 'Скопіювати посилання',
  newsFeedPostDetailsCopiedAlertText: 'Посилання скопійовано!',
  newsFeedPostDetailsUsersCurtainFlagOptionTitle: 'Поскаржитись',
  newsPostDetailsFlagCurtainOptionSpamTitle: 'Поскаржитись',
  newsPostDetailsReportedCurtainText: 'Скаргу надіслано',
  newsPostDetailsCommentOwnerCurtainEditOptionTitle: 'Редагувати коментар',
  newsPostDetailsCommentOwnerCurtainDeleteOptionTitle: 'Видалити коментар',
  newsPostDetailsEditedCommentSavedAlertText: 'Коментар збережено!',
  postDetailsOtherCommentAppOwnerCurtainOptionTitle: 'Видалити коментар',
  postDetailsOtherUsersCommentDeletadAlertText: 'Коментар видалено!',
  postDetailsDeleteCommentPopupTitle: 'Видалити',
  postDetailsDeleteCommentPopupText: 'Видалити цей коментар?',
  postDetailsDeleteCommentPopupCancelButtonTitle: 'Скасувати',
  postDetailsDeleteCommentPopupConfirmlButtonTitle: 'Підтвердити',
  postDetailsCommDeletedAlertText: 'Коментар видалено!',
  postDetailsCommentUserCurtainOptionTitle: 'Поскаржитись на коментар',
  newsCreatePostCurtainTitle: 'Новий допис',
  newsCreatePostCurtainBodyPlaceholder: 'Почніть писати тут...',
  newsCreatePostPublishButtonTitle: 'Опублікувати',
  newsCreatePostUploadSlallerImageAlertText: 'Ви не можете завантажувати більше {size} MB за раз',
  newsPostSavedAlertText: 'Допис збережено!',
  newsCreatePostAddLocationCurtainTitle: 'Локація',
  newsCreatePostAddLocationCurtainInputPlaceholder: 'Назва локації',
  newsCreatePostEditLocationCurtainText: 'Редагувати локацію',
  newsDeleteLocation: 'Видалити локацію',
  newsDiscardPostPopupTitle: 'Чернетка',
  newsDiscardPostPopupText: 'Видалити чернетку?',
  newsDiscardPostPopupCancelButtonTitle: 'Скасувати',
  newsDiscardPostPopupCofirmButtonTitle: 'Підтвердити',
  newsNewPostCreatePollTitle: 'Створити опитування',
  newsNewPostCreatePollTitleInputPlaceholder: 'Назва',
  newsNewPostCreatePollOptionInputPlaceholder: 'Варіант',
  newsNewPostCreatePollAddButtonTitle: 'Додати варіант',
  newsNewPostCreatePollCreateButtonTitle: 'Створити',
  newsCreatePostPollTitleBlankAlertText: 'Заповніть поле!',
  newsCreatePostPollOptionBlankAlertText: 'Заповніть поле!',
  newsCreatePostPollLongTitleAlertText: 'Задовга назва, оберіть не довше {length} символів',
  newsCreatePostPollLongOptionAlertText: 'Задовгий варіант, оберіть не довше {length} символів',
  newsCreatePostPollEditOptionTitle: 'Редагувати опитування',
  newsCreatePostPollRemoveOptionTitle: 'Видалити опитування',
  newsPostPollInfoVotesText: 'голосів',
  newsPostPollInfoEditVoteText: 'Переголосувати',
  newsPostPollFinishPollText: 'Завершити',
  newsPostPollFinishedPollText: 'Завершено',
  newsPostPollInProgresslText: 'В процесі',
  newsFinishPollCurtainTitle: 'Завершити',
  newsFinishPollCurtainText: 'Користувачі більше не зможуть голосувати в цьому опитуванні, коли воно буде закінчено.',
  newsFinishPollCurtainCancelButtonTitle: 'Скасувати',
  newsFinishPollCurtainConfirmlButtonTitle: 'Підтвердити',
  newsPollInfoPollVotesCurtainTitle: 'Голоси',
  newsEditPostCurtainTitle: 'Редагувати допис',
  newsEditPostCurtainNoTextBodyPlaceholder: 'Почніть писати тут...',
  newsEditPostCurtainSaveButtonTitle: 'Зберегти',
  newsEditPostSavedAlertText: 'Допис збережено!',
  newsError: 'Щось пішло не так!',
  newsAt: 'у',
  newsSeeMore: 'Розгорнути...',
  newsMaxAttachments: 'Ви перевищили максимальну кількість фотографій. Максимальна кількість становить {max} фото',
  newsReply: 'Відповісти',
  newsPin: 'Закріпити допис',
  newsUnpin: 'Відкріпити допис'
}
